import React from 'react'
import { TrendingUp, TrendingDown } from 'lucide-react'
import { cn } from '../../lib/utils'

const gradientMap = {
  indigo: 'from-indigo-500 to-purple-600',
  emerald: 'from-emerald-500 to-teal-600',
  blue: 'from-blue-500 to-cyan-600',
  amber: 'from-amber-500 to-orange-600',
  gray: 'from-gray-400 to-gray-500',
  rose: 'from-rose-500 to-pink-600',
}

export default function MetricCard({ icon: Icon, label, value, sublabel, change, color = 'indigo', onClick }) {
  const Wrapper = onClick ? 'button' : 'div'
  const gradient = gradientMap[color] || gradientMap.indigo

  return (
    <Wrapper
      onClick={onClick}
      className={cn(
        "rounded-2xl p-5 shadow-lg bg-gradient-to-br text-white",
        gradient,
        onClick && "cursor-pointer hover:shadow-xl transition-shadow"
      )}
    >
      <div className="flex items-center justify-between mb-3">
        <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center">
          {Icon && <Icon className="w-5 h-5 text-white" />}
        </div>
        {change !== undefined && change !== null && change !== 0 && (
          <div className={cn("flex items-center text-sm", change > 0 ? 'text-emerald-200' : 'text-red-200')}>
            {change > 0 ? <TrendingUp className="w-4 h-4 mr-1" /> : <TrendingDown className="w-4 h-4 mr-1" />}
            {Math.abs(change)}%
          </div>
        )}
      </div>
      <p className="text-3xl font-bold">{typeof value === 'number' ? value.toLocaleString() : value}</p>
      <p className="text-sm text-white/80 mt-1">{label}</p>
      {sublabel && <p className="text-xs text-white/60">{sublabel}</p>}
    </Wrapper>
  )
}
